const defaultAcceptApplicationTemplate1 = `Hi {{candidate_first_name}},

Thank you for applying to the {{position_name}} position at {{company_name}}.

I was impressed with your application and would like to move forward with the interview process.

I'll be in touch shortly to discuss next steps.

Kind regards,
{{sender_first_name}}`

const defaultAcceptApplicationTemplate2 = `Hello {{candidate_first_name}},

Thank you for your interest in the {{position_name}} role at {{company_name}}.

We've reviewed your application and would like to proceed with the next stage of our interview process.

I'll contact you soon to arrange an interview.

Best regards,
{{sender_first_name}}`

const defaultAcceptApplicationTemplate3 = `Hi {{candidate_first_name}},

We appreciate your application for the {{position_name}} position at {{company_name}}.

Your background aligns well with what we're looking for, and we'd like to invite you for an interview.

I'll reach out shortly to coordinate a time that works for you.

Cheers,
{{sender_first_name}}`

const defaultAcceptApplicationTemplate4 = `Dear {{candidate_first_name}},

Thank you for applying to join our team at {{company_name}} for the {{position_name}} role.

We're excited about your application and would like to move forward with the interview process.

I'll be in touch soon to schedule our conversation.

Warm regards,
{{sender_first_name}}`

const defaultAcceptApplicationTemplate5 = `Hi {{candidate_first_name}},

Thank you for your application for the {{position_name}} position at {{company_name}}.

We were impressed with your qualifications and would like to invite you for an interview.

I'll contact you in the next few days to arrange a time to speak.

Best,
{{sender_first_name}}`

const defaultAcceptApplicationTemplate6 = `Hi {{candidate_first_name}},

Thank you for taking the time to apply for the {{position_name}} position at {{company_name}}.

Your experience and skills caught our attention, and we'd like to learn more about you through an interview.

I'll be reaching out in the coming days to schedule a time to connect.

Kind regards,
{{sender_first_name}}`

const defaultAcceptApplicationTemplate7 = `Hello {{candidate_first_name}},

We're pleased to inform you that we'd like to move forward with your application for the {{position_name}} role at {{company_name}}.

Your background shows great potential, and we're excited to learn more about your experience and aspirations.

I'll be in touch soon to arrange an interview at a time that works for you.

Best regards,
{{sender_first_name}}`

const defaultAcceptApplicationTemplate8 = `Dear {{candidate_first_name}},

Thank you for your interest in joining {{company_name}} as a {{position_name}}.

After reviewing your application, we're impressed with your qualifications and would like to invite you for an interview.

I'll contact you shortly to coordinate a time that works for both of us.

Kind regards,
{{sender_first_name}}`

const defaultAcceptApplicationTemplate9 = `Hi {{candidate_first_name}},

We're excited to let you know that we'd like to move forward with your application for the {{position_name}} position at {{company_name}}.

Your experience aligns well with what we're looking for, and we'd love to learn more about you.

I'll be reaching out in the next few days to schedule an interview.

Warm regards,
{{sender_first_name}}`

const defaultAcceptApplicationTemplate10 = `Hello {{candidate_first_name}},

Thank you for applying to the {{position_name}} role at {{company_name}}.

We were impressed by your application and would like to set up an interview to discuss your experience and how you might add to our team.

I'll be in touch soon to arrange a time to speak.

Best regards,
{{sender_first_name}}`

const defaultAcceptApplicationTemplates = [
  defaultAcceptApplicationTemplate1,
  defaultAcceptApplicationTemplate2,
  defaultAcceptApplicationTemplate3,
  defaultAcceptApplicationTemplate4,
  defaultAcceptApplicationTemplate5,
  defaultAcceptApplicationTemplate6,
  defaultAcceptApplicationTemplate7,
  defaultAcceptApplicationTemplate8,
  defaultAcceptApplicationTemplate9,
  defaultAcceptApplicationTemplate10,
]

export default defaultAcceptApplicationTemplates
